import { makeStyles } from '@material-ui/core/styles';
import { addToDicionarioPaths, setTituloPagina } from 'painel/actions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AppTitleDesktop from './AppTitleDesktop';
import PropTypes from 'prop-types'; 
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    "&:focus": {
      boxShadow: '0 0 0 2px #c2850c',
      border: '1px solid #c2850c',
      outline: 'none'
    }
  },
}));

/**
 * ButtonAppBar
 * 
 * @param {Object} props
 * @param {string} [props.title] - Titulo da página
 * @returns {JSX.Element}
 */
export default function ButtonAppBar(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const {title} = props;
    if (title) {
      dispatch(setTituloPagina(title));
      dispatch(addToDicionarioPaths(location.pathname, title));
    }
  }, [props.title]);

  return (
    <header aria-label="Titulo da página" className={classes.root}>
      <AppTitleDesktop {...props} />
    </header>
  );
}

ButtonAppBar.propTypes = {
  title: PropTypes.string,
};

ButtonAppBar.defaultProps = {
  title: undefined,
};